import { SET_BUSY } from "./const";

export default {
    [SET_BUSY](state, busy) {
        state.busy = busy
    },
}